import React from "react";

import Button from "../../button/Button";
import useThemService from "../../../services/theme-service/ThemeService";

interface CancelButtonProps {
  disabled?: boolean;
  onClick?: () => void;
}

export default function CancelButton(props: CancelButtonProps) {
  const { themeClass } = useThemService();

  return (
    <Button
      id="cancel"
      textKey="general.cancel"
      className={themeClass(["btn-small", "fill-color-ghost"])}
      onClick={props.onClick}
    />
  );
}
